import constants from 'constants/index'

const label = (status) => {
  return constants.companySuppliers.STATUSES_LABELS[status] || '-'
}

export default label
